var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon09(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5553_66637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2 56C84.72 59.34 88 63.5 88 68C88 79.05 68.3 88 44 88C19.7 88 0 79.05 0 68C0 63.5 3.28 59.34 8.8 56C3.28 52.66 0 48.5 0 44C0 39.5 3.28 35.34 8.8 32C3.28 28.66 0 24.5 0 20C0 8.95 19.7 0 44 0C68.3 0 88 8.95 88 20C88 24.5 84.72 28.66 79.2 32C84.72 35.34 88 39.5 88 44C88 48.5 84.72 52.66 79.2 56Z",
    fill: "#62246B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5553_66637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon09);
export default __webpack_public_path__ + "static/media/icon_09.e4e6968303d7e6340758489a61358114.svg";
export { ForwardRef as ReactComponent };